export const mapApiFilters = (filters) => {
    if (!filters) {
        return [];
    }
    return filters.reduce((filters, filter) => {
        let key = `${filter.property}-${filter.operator}`;
        filters[key] = filter.value;
        return filters;
    }, {});
}